(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('DesignTemplateSavedModalCtrl', templateProductSavedModalCtrl);

    function templateProductSavedModalCtrl($scope, $mdDialog, templateId, designId, delayedSet) {
        $scope.templateId = templateId;
        $scope.designId = designId;
        $scope.delayedSet = delayedSet;
        $scope.title = $scope.designId ? 'Design Saved' : 'Design Template Saved';
        $scope.itWillTakeLonger = ' It will take a couple of minutes to be available';
        $scope.yourDesignHasaBeenSaved = 'Your design has been saved.';
        $scope.isEmbedded = new URLSearchParams(window.location.search).get('embedded') === 'true';
        $scope.goToDesignTemplates = function () {
            $mdDialog.hide();
        };
        $scope.onCloseClick = function () {
            window.parent.postMessage({ source: 'customily-app', type: 'close-app-window' }, '*');
        };
    }
})();
